export class User {
    constructor(id, email, is_active, is_superuser, is_verified, password, country) {
        this.id = id;
        this.email = email;
        this.is_active = is_active;
        this.is_superuser = is_superuser;
        this.is_verified = is_verified;
        this.password = password;
        this.country = country;
    }
}

export class NewUser {
    constructor(email, is_active, is_superuser, is_verified, password, country) {
        this.email = email;
        this.is_active = is_active;
        this.is_superuser = is_superuser;
        this.is_verified = is_verified;
        this.password = password;
        this.country = country;
    }
}